(function() {
    'use strict';
    
    function initSidebar() {
        const collectionURL = window.location.pathname;
        let matchFound = false;

        // First, check if any leaf menu items match
        const listMenuItems = document.querySelectorAll('.sidebar-menu .item-menu.list-menu__item');
        listMenuItems.forEach(item => {
            const itemURL = item.getAttribute('href');
            if (itemURL === collectionURL) {
                matchFound = true;
                item.classList.add('active');

                // Expand parent details and mark summaries as active
                let currentElement = item.parentElement;
                while (currentElement) {
                    if (currentElement.tagName === 'DETAILS') {
                        currentElement.open = true;
                        const summary = currentElement.querySelector(':scope > summary');
                        if (summary) {
                            summary.classList.add('active', 'active-parent');
                        }
                    }
                    currentElement = currentElement.parentElement;
                }
            }
        });

        // If no leaf item matched, check if any summary/parent items match
        if (!matchFound) {
            const summaryItems = document.querySelectorAll('.sidebar-menu summary');
            summaryItems.forEach(summary => {
                const link = summary.querySelector('a');
                const summaryURL = link ? link.getAttribute('href') : null;
                
                if (summaryURL === collectionURL) {
                    matchFound = true;
                    summary.classList.add('active', 'active-parent');
                    
                    // Open this details element
                    const detailsElement = summary.parentElement;
                    if (detailsElement && detailsElement.tagName === 'DETAILS') {
                        detailsElement.open = true;
                    }

                    // Expand all parent details and mark their summaries as active
                    let currentElement = summary.parentElement.parentElement;
                    while (currentElement) {
                        if (currentElement.tagName === 'DETAILS') {
                            currentElement.open = true;
                            const parentSummary = currentElement.querySelector(':scope > summary');
                            if (parentSummary) {
                                parentSummary.classList.add('active', 'active-parent');
                            }
                        }
                        currentElement = currentElement.parentElement;
                    }
                }
            });
        }
        
        // Mark all sidebar details as ready to show (fade-in)
        document.querySelectorAll('.sidebar-menu details').forEach(details => {
            details.classList.add('js-ready');
        });
    }
    
    // Run immediately if DOM is ready, otherwise wait
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSidebar);
    } else {
        initSidebar();
    }
})();

